<kendo-stacklayout [formGroup]="form" orientation="horizontal" gap="50">
  <div class="row">
    <div class="buffer">&nbsp;</div>
    @for (control of controls; track control.id) {
    @if(row.extend) {
    <div class="extendedRow">
      <app-form-control [form]="form" [control]="control" [submitted]="submitted"></app-form-control>
    </div>
    }
    @else {
    <div class="control">
      <app-form-control [form]="form" [control]="control" [submitted]="submitted"></app-form-control>
    </div>
    }
    }
    <div class="spacer">&nbsp;</div>
  </div>
</kendo-stacklayout>
